<template>
  <wc-dialog
    :showDialog='show_conflicts_dialog'
    title='List of all Snow Conflicts'
    hideCancel
    saveText='Close'
    @save='closeConflictsDialog'
    width='600'
>  
    <v-card-title class='body-1 font-weight-bold py-0'>
    Site Address and Location
    </v-card-title>
    <v-card-text>
    <ul>
        <li class='orange--text'>SAM - Site address missing</li>
        <li class='orange--text'>SCM - Site city missing</li>
        <li class='orange--text'>SPM - Site province missing</li>
        <li class='orange--text'>SPC - Site postal code missing</li>
        <li class='orange--text'>RGM - Route group missing</li>
        <li class='orange--text'>RNM - Route number missing</li>
        <li class='red--text font-weight-bold'>POH - Project On Hold</li>
    </ul>
    </v-card-text>
    <v-card-title class='body-1 font-weight-bold py-0'>
    Contacts
    </v-card-title>
    <v-card-text>
    <ul>
        <li class='red--text font-weight-bold'>NCM - Notices contact missing</li>
        <li class='red--text font-weight-bold'>MAM - Snail mail only: Notices contact mailing address missing</li>
        <li class='red--text font-weight-bold'>EAM - Notices contact email address missing</li>
        <li class='red--text font-weight-bold'>NCA - Notices contact archived</li>
        <li class='red--text font-weight-bold'>NCH - Notices contact is on hold</li>
        <li class='orange--text'>BNM - Billing contact missing</li>
        <li class='orange--text'>BAM - Billing contact's mailing address missing</li>
        <li class='orange--text'>BCM - Billing contact's mailing city missing</li>
        <li class='orange--text'>BPM - Billing contact's mailing province missing</li>
        <li class='orange--text'>BPC - Billing contact's mailing postal code missing</li>
        <li class='red--text font-weight-bold'>BCA - Billing contact archived</li>
        <li class='red--text font-weight-bold'>BCH - Billing contact is on hold</li>
    </ul>
    </v-card-text>
    <v-card-title class='body-1 font-weight-bold py-0'>
    Snow
    </v-card-title>
    <v-card-text>
    <ul>
        <li class='red--text font-weight-bold'>DRM - Driveway Rating Missing</li>
        <li class='red--text font-weight-bold'>DRP - Driveway Rating Price is missing</li>
    </ul>
    </v-card-text>
  </wc-dialog>
</template>

<script>
export default {
  name: 'staging-conflicts',
  props: {
    show_conflicts_dialog: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeConflictsDialog(){
      this.$emit('showConflictsDialog', false);
    }
  }
}
 
</script>